export default __webpack_public_path__ + "static/media/left-bg-end.b7f36125.png";